import { orchestrator } from 'satcheljs';
import { addGroupMemberSuccess, editGroupSuccess, popupOpened, popupClosed, } from 'owa-group-common';
var lpcGroupDataUpdateListener;
var lpcGroupMembersUpdateListener;
var lpcUpdatePopupStateListener;
export var setLpcGroupDataUpdateListener = function (listener) {
    lpcGroupDataUpdateListener = listener;
};
export var setLpcGroupMembersDataUpdateListener = function (listener) {
    lpcGroupMembersUpdateListener = listener;
};
export var setLpcUpdatePopupStateListener = function (listener) {
    lpcUpdatePopupStateListener = listener;
};
orchestrator(editGroupSuccess, function (actionMessage) {
    if (lpcGroupDataUpdateListener) {
        lpcGroupDataUpdateListener({
            Smtp: actionMessage.groupSmtp,
            AadObjectId: '',
            PersonaType: 'Group',
            OlsPersonaId: '',
        });
    }
});
orchestrator(addGroupMemberSuccess, function (actionMessage) {
    if (lpcGroupMembersUpdateListener) {
        lpcGroupMembersUpdateListener({
            Smtp: actionMessage.groupSmtp,
            AadObjectId: '',
            PersonaType: 'Group',
            OlsPersonaId: '',
        });
    }
});
orchestrator(popupOpened, function (actionMessage) {
    updatePopupState(actionMessage);
});
orchestrator(popupClosed, function (actionMessage) {
    updatePopupState(actionMessage);
});
function updatePopupState(popupStateUpdateData) {
    if (lpcUpdatePopupStateListener) {
        lpcUpdatePopupStateListener(popupStateUpdateData);
    }
}
//# sourceMappingURL=lpcDataUpdateListeners.js.map